export const isDateSimilar = (str_date1, str_date2, bufferTime) => {
  try {
    const date1 = new Date(str_date1);
    const date2 = new Date(str_date2);

    if (!_.isDate(date1) || !_.isDate(date2)) {
      return false;
    }

    return Math.abs(date1 - date2) < bufferTime;
  } catch (e) {
    return false;
  }
};